import React from 'react';
import styled from 'styled-components';
import {Image} from '../images';

export interface ImageAndTextCardLogoProps {
    logoImage?: string;
    color?: string;
    isSquare?: boolean;
    alignment?: 'left' | 'right';
}

const Styled = styled.div<{$color?: string}>`
    left: 32px;
    bottom: -24px;
    position: absolute;
    z-index: 2;
    background: ${(p) => p.$color || '#fff'};
    padding: 8px;
    img {
        object-position: 50% 50%;
        background: ${(p) => p.$color || '#fff'};
    }

    &.square {
        height: 134px;
        width: 134px;
        ${(p) => p.theme.breakpoints.down('md')} {
            height: 100px;
            width: 100px;
            left: 24px;
            padding: 4px;
        }
        ${(p) => p.theme.breakpoints.down('sm')} {
            height: 85px;
            width: 85px;
            bottom: -16px;
            left: 22px;
        }
        ${(p) => p.theme.breakpoints.down('xs')} {
            height: 65px;
            width: 65px;
            left: 14px;
        }
    }

    &.rect {
        padding: 4px 8px;
        height: 112px;
        width: 200px;
        ${(p) => p.theme.breakpoints.down('md')} {
            height: 90px;
            width: 160px;
            left: 24px;
        }
        ${(p) => p.theme.breakpoints.down('sm')} {
            height: 73px;
            width: 130px;
            bottom: -16px;
            left: 22px;
        }
        ${(p) => p.theme.breakpoints.down('xs')} {
            height: 56px;
            width: 100px;
            left: 14px;
        }
    }

    &.right {
        right: 32px;
        left: initial;
        &.rect {
            ${(p) => p.theme.breakpoints.down('md')} {
                right: 24px;
            }
            ${(p) => p.theme.breakpoints.down('sm')} {
                right: 22px;
            }
            ${(p) => p.theme.breakpoints.down('xs')} {
                right: 14px;
            }
        }
    }
`;

export const ImageAndTextCardLogo = ({
    logoImage,
    color,
    isSquare,
    alignment = 'left'
}: ImageAndTextCardLogoProps): JSX.Element | null => {
    if (!logoImage) return null;

    return (
        <Styled
            $color={color}
            className={`image-text-card-logo ${alignment === 'right' ? 'right' : 'left'} ${
                isSquare ? 'square' : 'rect'
            }`}>
            <Image ratio={isSquare ? 'square' : 'rect'} src={logoImage} fit="contain" />
        </Styled>
    );
};
